import { client, getSanityEditLink } from "./sanity-client";

document.addEventListener("DOMContentLoaded", async () => {
  // Set form action dynamically from external JSON config
  const contactForm = document.getElementById('contact_form');
  if (contactForm) {
    fetch('/assets/js/formConfig.json')
      .then(response => response.json())
      .then(config => {
        if (config.contactFormId) {
          contactForm.action = `https://formspree.io/f/${config.contactFormId}`;
        }
      })
      .catch(err => console.error("Error loading form config:", err));
  }

  // Form validation logic for submit button
  const submitBtn = document.getElementById('contact-submit-btn');

  if (contactForm && submitBtn) {
    const checkFormValidity = () => {
      if (contactForm.checkValidity()) {
        submitBtn.removeAttribute('disabled');
      } else {
        submitBtn.setAttribute('disabled', 'true');
      }
    };

    // Add event listeners to input fields
    const inputs = contactForm.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      input.addEventListener('input', checkFormValidity);
      input.addEventListener('change', checkFormValidity);
    });

    // Initial check
    checkFormValidity();
  }

  // Check if we are on the contact page
  const heroTitleEl = document.getElementById("contact-hero-title");
  if (!heroTitleEl) return;

  try {
    const query = `*[_type == "contact"][0]{
            ...,
            heroTitle,
            heroDescription,
            showContactInfo,
            showMap,
            _id
        }`;
    const data = await client.fetch(query);

    if (!data) {
      console.error("Contact data not found");
      return;
    }

    // Hero
    if (data._id) {
      heroTitleEl.parentElement.classList.add('position-relative');
      heroTitleEl.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'contact', 'heroTitle', 'Edit Hero Title'));
    }
    heroTitleEl.innerHTML = data.heroTitle;

    // Description
    const descriptionEl = document.getElementById("contact-hero-description");
    if (descriptionEl && data.heroDescription) {
      if (data._id) {
        descriptionEl.parentElement.classList.add('position-relative');
        descriptionEl.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'contact', 'heroDescription', 'Edit Description'));
      }
      descriptionEl.textContent = data.heroDescription;
    }

    // Map toggle
    if (data.showMap === false) {
      const mapIframe = document.getElementById("contact-map-iframe");
      const mobileMapIframe = document.getElementById("contact-map-iframe-mobile");
      if (mapIframe) mapIframe.closest('.col-12, .col-md-6, section').style.display = 'none';
      if (mobileMapIframe) mobileMapIframe.style.display = 'none';
    } else {
      const mapIframe = document.getElementById("contact-map-iframe");
      const mobileMapIframe = document.getElementById("contact-map-iframe-mobile");

      if (mapIframe && data.googleMapsEmbedSrc) {
        if (data._id) {
          mapIframe.parentElement.classList.add('position-relative');
          mapIframe.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'contact', 'googleMapsEmbedSrc', 'Edit Map'));
        }
        mapIframe.src = data.googleMapsEmbedSrc;
      }
      if (mobileMapIframe && data.googleMapsEmbedSrc) {
        mobileMapIframe.src = data.googleMapsEmbedSrc;
      }
    }

    // Contact Info toggle
    if (data.showContactInfo === false) {
      const emailLink = document.getElementById("contact-email-link");
      if (emailLink) emailLink.closest('.col-12, .col-md-6, section').style.display = 'none';
    } else {
      const emailLink = document.getElementById("contact-email-link");
      if (emailLink && data.email) {
        if (data._id) {
          emailLink.parentElement.parentElement.classList.add('position-relative');
          emailLink.parentElement.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'contact', 'email', 'Edit Contact Details'));
        }
        emailLink.href = `mailto:${data.email}`;
        emailLink.textContent = data.email;
      }

      const addressEl = document.getElementById("contact-address");
      if (addressEl && data.officeAddress) {
        if (data._id) {
          addressEl.parentElement.classList.add('position-relative');
          addressEl.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'contact', 'officeAddress', 'Edit Address'));
        }
        addressEl.innerHTML = data.officeAddress.replace(/^(Coriolis Technologies [I|II]*)/, '<span class="fw-bold">$1</span>');
      }

      // Social Links
      const socialContainer = document.getElementById("contact-social-container");
      if (socialContainer && data.socialLinks) {
        if (data._id) {
          socialContainer.classList.add('position-relative');
          socialContainer.insertAdjacentHTML('afterbegin', getSanityEditLink(data._id, 'contact', 'socialLinks', 'Edit Social Links'));
        }
      }

      const linkedinLink = document.getElementById("contact-social-linkedin");
      if (linkedinLink && data.socialLinks?.linkedin) {
        linkedinLink.href = data.socialLinks.linkedin;
      }

      const twitterLink = document.getElementById("contact-social-twitter");
      if (twitterLink && data.socialLinks?.twitter) {
        twitterLink.href = data.socialLinks.twitter;
      }

      const websiteLink = document.getElementById("contact-social-website");
      if (websiteLink && data.socialLinks?.website) {
        websiteLink.href = data.socialLinks.website;
      }
    }

  } catch (error) {
    console.error("Error fetching Contact data:", error);
  }


});
